module.exports = __webpack_public_path__ + "img/checkin_step4.08a6016d.jpg";